import { IBankAccountModel, routes } from '@linqpal/models'

export const getPaymentMethods = async () => {
  try {
    const resp = await routes.company.bankAccounts()
    if (!resp.bankAccounts) return null
    const bankAccountsWithMappedCardIds = resp.bankAccounts.map(
      (bankAccount) => {
        if (bankAccount.paymentMethodType === 'card') {
          bankAccount.accountType = bankAccount.cardMetadata.type
        }
        return bankAccount
      },
    )
    return bankAccountsWithMappedCardIds as unknown as IBankAccountModel[]
  } catch (err) {
    console.error(err)
    return null
  }
}
